import http from '.';

class DownloadAppService {
    getAndroidApp() {
        return http.get(`${http.url2}/downloadAndroidApp`);
    }
    getIOSApp() {
        return http.get(`${http.url2}/downloadIOSApp`);
    }
}

export default new DownloadAppService();
